import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth-interceptor';
import { API_BASE_URL } from './core/remote-clients/remote-client';
import { ConfigurationService } from './services/configuration.service.ts/configuration.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: API_BASE_URL,
      useFactory: (config: ConfigurationService) => {
        const apiBaseUrl = config.get<string>('apiBaseUrl');
        if (!apiBaseUrl) {
          throw new Error('apiBaseUrl is not configured in app.config.json');
        }
        return apiBaseUrl;
      },
      deps: [ConfigurationService],
    },
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: appLoadFactory,
      deps: [ConfigurationService],
      multi: true,
    },
    provideToastr({ positionClass: 'toast-bottom-right' }),
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: (config: ConfigurationService): RecaptchaSettings => {
        return { siteKey: config.recaptchaSiteKeyV2! };
      },
      deps: [ConfigurationService],
    },
    {
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
      deps: [PlatformLocation],
    },
  ],
};

function appLoadFactory(config: ConfigurationService) {
  return () => config.load();
}
